import mixpanel from 'mixpanel-browser';
import { globalSettings } from 'config';

export const loadMixPanel  = ()=>{
  const mixPanelApiHost  =  globalSettings.mixPanelApiHost !== '#{MIX_PANEL_API_HOST}' ?  globalSettings.mixPanelApiHost : undefined;
  mixpanel.init(globalSettings.mixPanelToken, {api_host: mixPanelApiHost, debug: false, track_pageview: false, persistence: 'localStorage'});
}
